import gsap from 'gsap';
import { Container } from '../../../odie';
import { DirectionId, SodaBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import SodaBottle, { SodaColor } from './components/SodaBottle';

/*
  Soda block view
*/
export class SodaBlockView extends Container {
  public static readonly FILL_ANIMATION_DURATION = 0.5;
  private _bottle: SodaBottle;
  private props: SodaBlockProps;
  private maxCount: number;

  constructor(props: SodaBlockProps, maxCount = 4) {
    super();
    this.props = props;
    this.maxCount = maxCount;
    this._bottle = new SodaBottle(props.color as SodaColor);
    this.addChild(this._bottle);
    blockPositionView(this, props);
    this._updateDirection(props.direction);
    // Starting fill ratio, from current count
    this._bottle.fillRatio = 1 - this.props.count / this.maxCount;
  }

  public static assets() {
    return SodaBottle.assets();
  }

  public playLaunchFx() {
    this._bottle.playLaunchFx();
  }

  public async updateFill(count: number) {
    const progress = 1 - count / this.maxCount;
    const diff = progress - this._bottle.fillRatio;

    // Only animate if there is an increment.
    if (diff > 0) {
      this._bottle.playFillFx();
      await gsap.to(this._bottle, {
        duration: SodaBlockView.FILL_ANIMATION_DURATION,
        fillRatio: progress,
        ease: 'quad.inOut',
        overwrite: true,
      });
      return;
    }

    this._bottle.fillRatio = progress;
  }

  private _updateDirection(direction: DirectionId) {
    this._bottle.x = 0;
    this._bottle.y = 0;
    switch (direction) {
      case 'up':
        this._bottle.rotation = 0;
        this.y += 6;
        break;
      case 'down':
        this._bottle.rotation = Math.PI;
        this.y += 4;
        break;
      case 'left':
        this._bottle.rotation = Math.PI * 0.5;
        this.y += 3;
        break;
      case 'right':
        this._bottle.rotation = Math.PI * 1.5;
        this.y += 3;
        break;
    }
  }
}
